import { GenericColDef, AlignDirection, SortByFilter, CellTemplateType, FilterTemplateType } from './grid-context';
import { DrEntity } from './dr-entity';
import { Report, ReportType } from './report';
import { ContextMenuOption } from './context-menu-option';
import { DocumentListColumnType } from '../components/document-list/document-list-info/document-list-column-info';
import { ObjectActionListType, ActionType } from '../models/permission';
import { EntityType } from '../models/enums';
import * as _ from 'underscore';
import { formatDate } from 'ngx-bootstrap/chronos';

export enum DetailsType {
    SCAN_HISTORY = 'SCAN_HISTORY',
    EXCEPTION_DETAILS = 'EXCEPTION_DETAILS',
    EXCEPTION_DETAILS_IMPORT = 'EXCEPTION_DETAILS_IMPORT',
    ZERO_DAY_DETAILS = 'ZERO_DAY_DETAILS',
    STANDARD_DETAILS = 'STANDARD_DETAILS',
}

export enum DocumentHeaderType {
    IMPORT = 'IMPORT',
    NON_IMPORT = 'NON_IMPORT'
}

export enum DocType {
    DOCEXT = 'DOCEXT',
    FILETYPE = 'FILETYPE',
    DOCEXT_CONFLICT = 'DOCEXT_CONFLICT',
}

enum ReportDetailsColumnType {
    date,
    dayOfWeek,
    group,
    scanHistoryDate,
    user,
    filesAdded,
    filesSize,
    batch,
    electronicId,
    shipmentDate,
    shipperName,
    trackingNumber,
    dateReceived,
    recepientName,
    checkbox,
    name,
    count,
    size,
    recommended,
    docNumber,
    importPath,
    code,
    reason,
    filetype,
    dateProcessed,
    downloadButton,
    auxparsingstatus
}

enum DocumentListHeaderButtonOptionType {
    addTags = 'addTags',
    addTagsImport = 'addTagsImport',
    removeTags = 'removeTags',
    addTo = 'addTo',
    addToImport = 'addToImport',
    removeFrom = 'removeFrom',
    addToDomainList = 'addToDomainList'
}

const allDocumentListHeaderButtonOptions: ReadonlyMap<DocumentListHeaderButtonOptionType, ContextMenuOption> = new Map<DocumentListHeaderButtonOptionType, ContextMenuOption>([
    [DocumentListHeaderButtonOptionType.addTags, new ContextMenuOption({
        name: 'Add Tags ...', visible: true, enabled: true,
        iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.addTagsImport, new ContextMenuOption({
        name: 'Add Tags ...', visible: true, enabled: true,
        iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.removeTags, new ContextMenuOption({
        name: 'Remove Tags ...', visible: true, enabled: true,
        iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.addTo, new ContextMenuOption({
        name: 'Add to ...', visible: true, enabled: true,
        iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    })],
    [DocumentListHeaderButtonOptionType.addToImport, new ContextMenuOption({
        name: 'Add to ...', visible: true, enabled: true,
        iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE], isMandatory: true },
        { permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    })],
    [DocumentListHeaderButtonOptionType.removeFrom, new ContextMenuOption({
        name: 'Remove from ...', visible: true, enabled: true,
        iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    })],
    [DocumentListHeaderButtonOptionType.addToDomainList, new ContextMenuOption({
        name: 'Add to Domain List ...', visible: true, enabled: true,
        iconClass: 'fa-at', iconColor: 'color-grey-10',
        permissions: [{ permissionType: ObjectActionListType.PRJ_DOMAIN_LISTS, permissionActions: [ActionType.CREATE] }]
    })]
]);

export const DocumentListHeaderButtonOptionsInfo: ReadonlyMap<DocumentHeaderType, Array<ContextMenuOption>> = new Map<DocumentHeaderType, Array<ContextMenuOption>>([
    [DocumentHeaderType.IMPORT, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTagsImport),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToImport),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToDomainList)
    )],
    [DocumentHeaderType.NON_IMPORT, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToDomainList)
    )]
]);


const reportDetailsColumns: ReadonlyMap<ReportDetailsColumnType, (type: DocType, reportType: ReportType) => any> = new Map<ReportDetailsColumnType, (type: DocType, reportType: ReportType) => any>([
    [ReportDetailsColumnType.date, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Date',
        field: 'name',
        automationId: '',
        lockVisible: true,
    }],
    [ReportDetailsColumnType.dayOfWeek, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Day Of Week',
        field: 'count',
        automationId: '',
    }],
    [ReportDetailsColumnType.group, (type: DocType, reportType: ReportType) => <any>{
        headerName: reportType === ReportType.BILLING_REPORT ? 'Group' : null,
        field: 'blockSize',
        automationId: '',
        hide: reportType === ReportType.BILLING_REPORT ? false : true,
        sortBy: SortByFilter.ORG,
    }],
    [ReportDetailsColumnType.scanHistoryDate, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Date',
        field: 'date',
        automationId: 'date',
        lockVisible: true,
    }],
    [ReportDetailsColumnType.user, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'User',
        field: 'userName',
        automationId: 'user',
    }],
    [ReportDetailsColumnType.filesAdded, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Files Added',
        field: 'fileCount',
        automationId: 'files-added',
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        width: 110,
        suppressSizeToFit: true,
    }],
    [ReportDetailsColumnType.filesSize, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Size of Files',
        field: 'size',
        automationId: 'files-size',
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        width: 130,
        suppressSizeToFit: true,
    }],
    [ReportDetailsColumnType.batch, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Batch',
        field: 'batchNumber',
        automationId: 'batch',
    }],
    [ReportDetailsColumnType.electronicId, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Electronic ID',
        field: 'electronicId',
        automationId: 'electronic-id',
    }],
    [ReportDetailsColumnType.shipmentDate, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Date of Shipment',
        field: 'dateOfShipment',
        automationId: 'shipment-date',
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
    }],
    [ReportDetailsColumnType.shipperName, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Name of Shipper',
        field: 'nameOfShipper',
        automationId: 'shipper-name',
    }],
    [ReportDetailsColumnType.trackingNumber, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Tracking Number',
        field: 'trackingNumber',
        automationId: 'tracking-number',
    }],
    [ReportDetailsColumnType.dateReceived, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Date Received',
        field: 'dateReceived',
        automationId: 'date-received',
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
    }],
    [ReportDetailsColumnType.recepientName, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Recipient Name',
        field: 'nameOfRecipient',
        automationId: 'recipient-name',
    }],
    [ReportDetailsColumnType.checkbox, (type: DocType, reportType: ReportType) => <any>{
        colId: 'checkbox',
        automationId: '',
        checkboxSelection: true, headerCheckboxSelection: true,
        minWidth: 36, maxWidth: 36, width: 36,
        suppressSizeToFit: true, suppressMovable: true,
        hide: reportType === ReportType.BILLING_REPORT ? true : false
    }],
    [ReportDetailsColumnType.name, (type: DocType, reportType: ReportType) => <any>{
        headerName: type === DocType.DOCEXT_CONFLICT ? 'Current' :
            (reportType === ReportType.DATE_PRIMARY || reportType === ReportType.DATE_EMAIL_SENT || reportType === ReportType.DATE_EMAIL_RECEIVED) ? 'Date' : 'Name',
        field: 'name',
        automationId: '',
        width: 220,
        headerAlignDirection: AlignDirection.left,
        cellAlignDirection: AlignDirection.left,
        serviceTierFilter: false,
        lockVisible: true,
        sortBy: SortByFilter.NAME,
    }],
    [ReportDetailsColumnType.recommended, (type: DocType, reportType: ReportType) => <any>{
        headerName: type === DocType.DOCEXT_CONFLICT ? 'Recommended' : null,
        field: 'blockSize',
        automationId: '',
        headerAlignDirection: AlignDirection.left,
        cellAlignDirection: AlignDirection.left,
        hide: type === DocType.DOCEXT_CONFLICT ? false : true,
        sortBy: SortByFilter.NAME,
    }],
    [ReportDetailsColumnType.count, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Count',
        field: 'count',
        automationId: '',
        width: 100,
        suppressSizeToFit: true,
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        sortBy: SortByFilter.COUNT,
    }],
    [ReportDetailsColumnType.size, (type: DocType, reportType: ReportType) => <any>{
        headerName: 'Size',
        field: 'size',
        automationId: '',
        width: 110,
        suppressSizeToFit: true,
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        sortBy: reportType === null ? null : SortByFilter.SIZE
    }],
    [ReportDetailsColumnType.docNumber, (type: DocType) => <any>{
        headerName: 'Doc Number',
        field: 'docNumber',
        automationId: 'doc-number',
        width: 130,
        suppressSizeToFit: true,
        lockVisible: true
    }],
    [ReportDetailsColumnType.importPath, (type: DocType) => <any>{
        headerName: 'Import Path',
        field: 'importPath',
        automationId: 'import-path',
        width: 450,
    }],
    [ReportDetailsColumnType.code, (type: DocType) => <any>{
        headerName: 'Code',
        field: 'code',
        automationId: 'code',
        width: 130,
        suppressSizeToFit: true,
    }],
    [ReportDetailsColumnType.reason, (type: DocType) => <any>{
        headerName: 'Reason',
        field: 'reason',
        automationId: 'reason',
        filterType: FilterTemplateType.singleChoice,
        serviceTierFilter: true,
    }],
    [ReportDetailsColumnType.auxparsingstatus, (type: DocType) => <any>{
        headerName: 'auxparsingstatus',
        field: 'auxparsingstatus',
        automationId: 'auxparsingstatus',
        filterType: FilterTemplateType.singleChoice,
        serviceTierFilter: true
    }],
    [ReportDetailsColumnType.filetype, (type: DocType) => <any>{
        headerName: 'File Type',
        field: 'filetype',
        automationId: 'file-type',
        filterType: FilterTemplateType.singleChoice,
        serviceTierFilter: true,
    }],
    [ReportDetailsColumnType.dateProcessed, (type: DocType) => <any>{
        headerName: 'Date Processed',
        field: 'dataProcessed',
        automationId: 'date-processed',
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        width: 180,
        suppressSizeToFit: true
    }],
    [ReportDetailsColumnType.downloadButton, (type: DocType) => <any>{
        headerName: '',
        automationId: 'download',
        cellTemplateType: CellTemplateType.download,
        minWidth: 30, maxWidth: 30, width: 30,
        suppressSizeToFit: true
    }]
]);

export const ReportDetailsDefinitions: ReadonlyMap<DetailsType, (type: DocType, reportType: ReportType) => Array<GenericColDef>> =
    new Map<DetailsType, (type: DocType, reportType: ReportType) => Array<GenericColDef>>([
        [DetailsType.ZERO_DAY_DETAILS, (type: DocType, reportType: ReportType) => Array<GenericColDef>(
            reportDetailsColumns.get(ReportDetailsColumnType.date)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.dayOfWeek)(type, reportType)
        )],
        [DetailsType.EXCEPTION_DETAILS, (type: DocType, reportType: ReportType) => Array<GenericColDef>(
            reportDetailsColumns.get(ReportDetailsColumnType.checkbox)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.name)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.recommended)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.count)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.size)(type, reportType)
        )],
        [DetailsType.STANDARD_DETAILS, (type: DocType, reportType: ReportType) => Array<GenericColDef>(
            reportDetailsColumns.get(ReportDetailsColumnType.group)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.checkbox)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.name)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.count)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.size)(type, reportType)
        )],
        [DetailsType.SCAN_HISTORY, (type: DocType, reportType: ReportType) => Array<GenericColDef>(
            reportDetailsColumns.get(ReportDetailsColumnType.scanHistoryDate)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.user)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.filesAdded)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.filesSize)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.batch)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.electronicId)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.shipmentDate)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.shipperName)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.trackingNumber)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.dateReceived)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.recepientName)(type, reportType)
        )],
        [DetailsType.EXCEPTION_DETAILS_IMPORT, (type: DocType, reportType: ReportType) => Array<GenericColDef>(
            reportDetailsColumns.get(ReportDetailsColumnType.docNumber)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.importPath)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.code)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.reason)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.auxparsingstatus)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.filetype)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.size)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.dateProcessed)(type, reportType),
            reportDetailsColumns.get(ReportDetailsColumnType.downloadButton)(type, reportType)
        )],
    ]);

export const ReportDetailsMap: Map<DetailsType, (report: any) => any> = new Map<DetailsType, (report: any) => any>([
    [DetailsType.ZERO_DAY_DETAILS, (report: any) => <any>{
        title: report.detailsTitle + ' Zero Day Details',
        automationId: 'zero-day-details',
        report: report,
        modalWidth: '600',
        isDownloadButtonPresent: true
    }],
    [DetailsType.EXCEPTION_DETAILS, (report: any) => <any>{
        title: 'Document Type Details',
        automationId: 'document-type-details',
        report: report,
        isDownloadButtonPresent: true,
        sortBy: 'COUNT',
        documentHeaderButtonOptions: DocumentListHeaderButtonOptionsInfo.get(report.node.entityType === EntityType.import || report.node.entityType === EntityType.searchResultImport ?
            DocumentHeaderType.IMPORT : DocumentHeaderType.NON_IMPORT),
    }],
    [DetailsType.STANDARD_DETAILS, (report: any) => <any>{
        title: report.detailsTitle + ' Details',
        automationId: report.detailsTitle.toLowerCase().replace(/ /g, '-') + '-details',
        report: report,
        modalWidth: report.reportType === ReportType.BILLING_REPORT ? '750' : '500',
        isDownloadButtonPresent: report.reportType === ReportType.BILLING_REPORT ? false : true,
        sortBy: 'COUNT',
        documentHeaderButtonOptions: DocumentListHeaderButtonOptionsInfo.get(report.node.entityType === EntityType.import || report.node.entityType === EntityType.searchResultImport ?
            DocumentHeaderType.IMPORT : DocumentHeaderType.NON_IMPORT),
    }],
]);
export class ReportDetails extends DrEntity {

    dateUpdated: string;
    reportEntryList: any[];
    reportData: string[];
    totalCount: number;
    reportType: string;
    formatedData: any[];

    constructor(value?: Partial<Report>) {
        super(value);
        this.formatedData = [];
        if (value && value.reportData && value.reportData.length > 0) {
            let colNames = value.reportData[0].split(',');
            colNames = colNames.map(f => f.replace(/ /g, '').toLowerCase());
            for (let i = 1; i < value.reportData.length; i++) {
                const data = value.reportData[i].split(',');
                const searchEntry = new Object;
                for (let index = 0; index < data.length; index++) {
                    searchEntry[colNames[index]] = data[index];
                }
                this.formatedData.push(searchEntry);
            }
        }
    }
}

export class ScanHistory extends DrEntity {
    date: string;
    description: string;
    fileCount: number;
    size: string;
    userName: string;
    dateOfShipment = '';
    dateReceived = '';
    batchNumber = '';
    electronicId = '';
    nameOfRecipient = '';
    nameOfShipper = '';
    trackingNumber = '';
    constructor(value?: Partial<ScanHistory>) {
        super(value);
        if (value.attributes) {
            value.attributes.forEach(attribute => {
                // attributes
                if (attribute.name === 'shipmentDate' && !_.isEmpty(attribute.value)) {
                    this.dateOfShipment = formatDate(new Date(attribute.value), 'YYYY-MM-DD HH:mm:ss', null, true);
                }
                if (attribute.name === 'receiptDate' && !_.isEmpty(attribute.value)) {
                    this.dateReceived = formatDate(new Date(attribute.value), 'YYYY-MM-DD HH:mm:ss', null, true);
                }
                if (attribute.name === 'batch') { this.batchNumber = attribute.value; }
                if (attribute.name === 'ediinNumber') { this.electronicId = attribute.value; }
                if (attribute.name === 'recipientName') { this.nameOfRecipient = attribute.value; }
                if (attribute.name === 'shipperName') { this.nameOfShipper = attribute.value; }
                if (attribute.name === 'shipperTrackingNumber') { this.trackingNumber = attribute.value; }
            });
        }
    }
}

export class ExceptionDetails extends DrEntity {
    filetype: string;
    docNumber: string;
    importPath: string;
    size: string;
    dataProcessed: string;
    auxparsingstatus: string;
    code = '';
    reason = '';
    constructor(value?: Partial<ExceptionDetails>) {
        super(value);
        if (value.attributes) {
            value.attributes.forEach(attribute => {
                // attributes
                if (attribute.name === DocumentListColumnType.auxparsingstatus) { this.auxparsingstatus = attribute.value; }
                if (attribute.name === DocumentListColumnType.filetype) { this.filetype = attribute.value; }
                if (attribute.name === DocumentListColumnType.docnum) { this.docNumber = attribute.value; }
                if (attribute.name === DocumentListColumnType.datescanned) {
                    const datetime = attribute.value.split('-');
                    this.dataProcessed = datetime[0] + '-' + datetime[1] + '-' + datetime[2] + ' ' + datetime[3] + ':' + datetime[4] + ':' + datetime[5];
                }
                if (attribute.name === DocumentListColumnType.importpath) { this.importPath = attribute.value; }
                if (attribute.name === DocumentListColumnType.parsingstatus) {
                    this.code = attribute.value.split(' ')[0];
                    this.reason = attribute.value.split(' ')[1];
                }
                if (attribute.name === DocumentListColumnType.size) { this.size = attribute.value.replace(' B', ''); }
            });
        }
    }
}
